export { default as PageNotFound } from './PageNotFound';



// WEBPACK FOOTER //
// ./src/features/common/index.js